import { memo, useState } from "react";
import { Collapse, Button, Spin, Typography, Badge, Space, Modal, Tabs, message } from "antd";
import { FullscreenOutlined, ShoppingCartOutlined, CodeOutlined, CopyOutlined } from "@ant-design/icons";
import styles from "../styles/UberSyncUI.module.css";

const { Text } = Typography;
const { Panel } = Collapse;
const { TabPane } = Tabs;

const MenuPreviewPanel = ({ previewLoading, previewMenu, previewRawPayload, liveRawPayload, onOpenDrawer }) => {
  const [jsonModalVisible, setJsonModalVisible] = useState(false);

  const handleCopy = (payload) => {
    if (payload) {
      navigator.clipboard.writeText(JSON.stringify(payload, null, 2));
      message.success("JSON copiado al portapapeles");
    }
  };
  return (
    <div className={styles.previewPanel}>
      <div className={styles.titleArea}>
        <span className={styles.titleText}>
          <ShoppingCartOutlined /> Menú a Sincronizar (Global)
        </span>
        <Space>
          {previewMenu && (
            <Badge count={`${previewMenu.length} Categorías`} style={{ backgroundColor: '#1890ff' }} />
          )}
          <Button
            type="text"
            icon={<CodeOutlined />}
            onClick={() => setJsonModalVisible(true)}
            title="Ver JSON Raw"
            disabled={!previewRawPayload && !liveRawPayload}
          />
          <Button
            type="text"
            icon={<FullscreenOutlined />}
            onClick={onOpenDrawer}
            title="Ampliar vista del menú"
          />
        </Space>
      </div>

      <Modal
        title="Comparación JSON - Uber Eats"
        visible={jsonModalVisible}
        onCancel={() => setJsonModalVisible(false)}
        footer={null}
        width={900}
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto", padding: "1rem" }}
      >
        <Tabs defaultActiveKey="local">
          <TabPane tab="JSON Local (A Enviar)" key="local">
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '8px' }}>
              <Button size="small" icon={<CopyOutlined />} onClick={() => handleCopy(previewRawPayload)}>Copiar JSON</Button>
            </div>
            <pre style={{ backgroundColor: "#f5f5f5", padding: "1rem", borderRadius: "8px" }}>
              {previewRawPayload ? JSON.stringify(previewRawPayload, null, 2) : "Cargando..."}
            </pre>
          </TabPane>
          <TabPane tab="JSON Uber (En Producción)" key="live">
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '8px' }}>
              <Button size="small" icon={<CopyOutlined />} onClick={() => handleCopy(liveRawPayload)}>Copiar JSON</Button>
            </div>
            <pre style={{ backgroundColor: "#f5f5f5", padding: "1rem", borderRadius: "8px" }}>
              {liveRawPayload ? JSON.stringify(liveRawPayload, null, 2) : "No disponible o sin cargar."}
            </pre>
          </TabPane>
        </Tabs>
      </Modal>

      {previewLoading ? (
        <div className={styles.spinnerContainer}>
          <Spin size="large" tip="Generando estructura del menú..." />
        </div>
      ) : (
        <div className={styles.rightTreeContainer}>
          {previewMenu && previewMenu.length > 0 ? (
            <Collapse accordion bordered={false}>
              {previewMenu.map((cat) => (
                <Panel
                  header={
                    <span className={styles.categoryNode}>
                      {cat.name.toUpperCase()}
                    </span>
                  }
                  key={cat.id}
                >
                  <div className={styles.productListNode}>
                    {cat.products && cat.products.length > 0 ? (
                      cat.products.map((prod) => (
                        <div
                          key={prod.sku}
                          className={`${styles.productNode} ${styles.productRow}`}
                        >
                          <span>{prod.name} <Text type="secondary">({prod.sku})</Text></span>
                          <span className={styles.productPrice}>${(prod.price || 0).toFixed(2)}</span>
                        </div>
                      ))
                    ) : (
                      <Text type="secondary" italic>No hay productos activos en esta categoría</Text>
                    )}
                  </div>
                </Panel>
              ))}
            </Collapse>
          ) : (
            <div className={styles.spinnerContainer}>
              <Text type="secondary" italic>No se generaron categorías activas en el menú</Text>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default memo(MenuPreviewPanel);
